export default __webpack_public_path__ + "static/media/jpg.c422e00a.svg";